import React, { useEffect, useState } from "react";
import { View, Text } from "react-native";

import cardStyles from "../cardStyles";
import GoalPresetsList from "../../../resolution/goals/GoalPresetsList";
import SnoozeIcon from "../../../common/dialog/SnoozeIcon";
import CardUtils from "../CardUtils";

export default function GoalsPresetsCard({
  controller,
  data,
  onSnooze = null,
}) {
  const goals = controller.state.goal_presets;

  const [showCard, setShowCard] = useState(goals != null);
  const cardUtils = new CardUtils(controller, data, setShowCard);

  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  return !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { paddingTop: 0 }]}>
        <SnoozeIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          style={cardStyles.closeButton}
        />

        <View style={{ flex: 1 }}>
          <GoalPresetsList controller={controller} isFromCard>
            {/* Header */}
            <View
              style={[cardStyles.header, { paddingHorizontal: 0, height: 30 }]}
            >
              <View style={[cardStyles.headerInfo, { marginLeft: 6 }]}>
                <Text style={[cardStyles.title]}>Set a Weekly Goal</Text>
              </View>
            </View>
          </GoalPresetsList>
        </View>
      </View>
    </View>
  );
}
